import type {FeatureData} from './catalog';
import {FeatureInstance, FeatureOwner, flattenChoices} from './feature-tree';
import {propsAtLevel} from './level-props';
import type {FeatureProps} from './types';

export type PropsSource = {
	/** экземпляр особенности или выбранный вариант: по нему считаются потраченные использования */
	key: string;
	/** экземпляр особенности, к которой относятся props */
	featureKey: string;
	props: FeatureProps;
	feature: FeatureData;
	/** название для списков: особенность или «особенность: вариант» */
	title: string;
	owner: FeatureOwner;
	/** области поиска ссылок на выборы, от ближней к дальней */
	scopes: string[];
};

export function collectPropsSources(features: FeatureInstance[]): PropsSource[] {
	return features.flatMap((instance) => {
		const {feature, owner} = instance;
		const scopes = [instance.key, owner.key];

		const featureSources: PropsSource[] = instance.props
			? [
					{
						key: instance.key,
						featureKey: instance.key,
						props: instance.props,
						feature,
						title: feature.title,
						owner,
						scopes,
					},
			  ]
			: [];

		const optionSources = flattenChoices(instance.choices).flatMap((choice) =>
			(choice.group.options || [])
				.filter((option) => option.props && choice.selected.includes(option.key))
				.map(
					(option): PropsSource => ({
						key: `${choice.key}>${option.key}`,
						featureKey: instance.key,
						props: propsAtLevel(option.props, owner.level) || {},
						feature,
						title: option.label ? `${feature.title}: ${option.label}` : feature.title,
						owner,
						scopes,
					}),
				),
		);

		return [...featureSources, ...optionSources];
	});
}
